import { selectOrdinal, t } from '@lingui/core/macro'

/**
 * Messages génériques centralisés (autocomplete + évite les variantes involontaires).
 */
const msgCore = {
  get activiteTerminee (): string { return t`Activité terminée` },
  get anger (): string { return '😣' },
  get attentionTempsLimite (): string { return t`Attention, temps limité` },
  get bug (): string { return t`Cette ressource a rencontré un problème\u202F: prenez une capture d\`écran et signalez le à votre professeur.` },
  get cBien (): string { return t`C’est bien\u202F!` },
  get cFaux (): string { return t`C’est faux\u202F!` },
  get confused (): string { return '😕' },
  get correctPasSimplifie (): string { return t`La réponse est correcte mais pas simplifiée\u202F!` },
  get erreurInterneAvecDetails (): string { return t`Erreur interne, désolé. Cet exercice (ou le suivant qui allait démarrer) présente une anomalie, fais une capture d’écran et explique à ton professeur comment c’est arrivé pour qu’il puisse le signaler.` },
  get erreurSurvenue (): string { return t`Une erreur est survenue` },
  get essaieEncore (): string { return t`Essaie encore\u202F!` },
  /** Retourne le suffixe à mettre en exposant après le rang (cas féminin) */
  formatOrdinalExpF: (count: number): string => t({
    context: 'exposant ordinal féminin',
    message: selectOrdinal(count, {
      few: 'e',
      one: 're',
      other: 'e',
      two: 'e',
    })
  }),
  /** Retourne le suffixe à mettre en exposant après le rang (cas masculin) */
  formatOrdinalExpM: (count: number): string => t({
    context: 'exposant ordinal masculin',
    message: selectOrdinal(count, {
      few: 'e',
      one: 'er',
      other: 'e',
      two: 'e',
    })
  }),
  get impossibleContinuer (): string { return t`Impossible de continuer` },
  get info (): string { return t`Info` },
  get maxRuns (): string { return t`exécution(s) max` },
  get maxTries (): string { return t`essai(s) max` },
  get minute (): string { return t`minute` },
  get minutes (): string { return t`minutes` },
  get nbQuestions (): string { return t`nombre de questions` },
  get nbSteps (): string { return t`nombre d’étapes` },
  get noeud (): string { return t`Nœud\u202F:` + ' ' },
  get parcoursFini (): string { return t`Parcours terminé` },
  get parcoursTermine (): string {
    return t`Ce parcours a déjà été terminé.
Si tu fermes cette boite de dialogue,
il reprendra du début
(sinon choisis un autre exercice).`
  },
  get partez (): string { return t`Partez` },
  get pasDeQuestionInteractive (): string { return t`Pas de question interactive` },
  get pret (): string { return t`Prêt\u202F?` },
  get question (): string { return t`Question\u202F:` + ' ' },
  get regardeCorrection (): string { return t`Regarde la correction.` },
  get reponseIncomplete (): string { return t`Réponse incomplète` },
  get reponseManquante (): string { return t`Il faut donner une réponse\u202F!` },
  get sansScore (): string { return t`Sans score` },
  scoreGlobal: (scorePc: number): string => t`Score global\u202F: ${scorePc}%`,
  get seconde (): string { return t({ context: 'time', message: 'seconde' }) },
  get secondes (): string { return t({ context: 'time', message: 'secondes' }) },
  get section (): string { return t`section` },
  get sectionSuivante (): string { return t`Section suivante` },
  get smile (): string { return '🙂' },
  get suite (): string { return t`Suite` },
  get sur (): string { return t`sur` },
  get tempsDepasse (): string { return t`Temps dépassé\u202F!` },
  get tempsLimite1 (): string { return t`Cet exercice est en temps limité, tu auras` + ' ' },
  get tempsLimite2 (): string { return ' ' + t`par question.` },

  // on ajoute des fonctions, toutes préfixées par `format`

  /* pour le cas ordinal, la doc lingui donne en exemple
https://js-lingui-git-next-crowdin.vercel.app/ref/macro#selectordinal
  const message = selectOrdinal(count, {
    one: "#st",
    two: "#nd",
    few: "#rd",
    other: "#th",
  });

pour l'anglais, `few` correspond justement à 3, mais ça dépend des langues
cf https://www.unicode.org/cldr/charts/48/supplemental/language_plural_rules.html
https://github.com/unicode-cldr/cldr-core/blob/master/supplemental/plurals.json

=> On gère dans des fonctions génériques ces cas
    */

  get tempsPasse (): string { return t`Temps passé\u202F:` + ' ' },
  get wrongAnswer (): string { return t`Cela ne répond pas correctement à la question, relis l’énoncé` },
} as const

export default msgCore
